/**
 * Structured Data (JSON-LD) generators for SEO
 */

export const generateWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "CodingComet",
  url: "https://codingcomet.in",
  description: "Learn programming with interactive tutorials, code playgrounds, and hands-on projects",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "https://codingcomet.in/?search={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
});

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "CodingComet",
  url: "https://codingcomet.in",
  logo: "https://codingcomet.in/logo512.png",
  description: "Educational platform for learning programming",
  sameAs: [
    // Add your social media links
    // "https://twitter.com/codingcomet",
    // "https://github.com/codingcomet",
  ],
});

export const generateCourseSchema = (course) => ({
  "@context": "https://schema.org",
  "@type": "Course",
  name: course.title || course.name,
  description: course.description || "Programming course",
  provider: {
    "@type": "Organization",
    name: "CodingComet",
    url: "https://codingcomet.in",
  },
  courseCode: course.content_id,
  inLanguage: "en-US",
  educationalLevel: "Beginner to Advanced",
});

export const generateArticleSchema = (article) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: article.title,
  description: article.description || article.title,
  image: article.image || "https://codingcomet.in/og-image.png",
  datePublished: article.datePublished || new Date().toISOString(),
  dateModified: article.dateModified || new Date().toISOString(),
  author: {
    "@type": "Organization",
    name: "CodingComet",
  },
  publisher: {
    "@type": "Organization",
    name: "CodingComet",
    logo: {
      "@type": "ImageObject",
      url: "https://codingcomet.in/logo512.png",
    },
  },
});

export const generateBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

export const generateSoftwareApplicationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "CodingComet Code Playground",
  applicationCategory: "EducationalApplication",
  operatingSystem: "Web Browser",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.8",
    ratingCount: "100",
  },
});

